import { combineReducers } from '@reduxjs/toolkit';
import { auditLogsApi } from '@/features/audit-logs/audit-logs.api.ts';
import { authApi } from '@/features/auth/auth.api.ts';
import { authSlice } from '@/features/auth/auth.slice.ts';
import { dataMaskingApi } from '@/features/data-masking/data-masking.api.ts';
import { fundManagementApi } from '@/features/fund-management/fund-management.api.ts';
import { investorManagementApi } from '@/features/investor-management/investor-management.api.ts';
import { investmentsApi } from '@/features/investor-management/investments.api.ts';
import { referenceDataApi } from '@/features/reference-data/reference-data.api.ts';
import { reportsApi } from '@/features/reports/reports.api.ts';
import { userPreferencesApi } from '@/features/user-preferences/user-preferences.api.ts';

export const appReducer = combineReducers({
  [auditLogsApi.reducerPath]: auditLogsApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [dataMaskingApi.reducerPath]: dataMaskingApi.reducer,
  [fundManagementApi.reducerPath]: fundManagementApi.reducer,
  [investorManagementApi.reducerPath]: investorManagementApi.reducer,
  [investmentsApi.reducerPath]: investmentsApi.reducer,
  [referenceDataApi.reducerPath]: referenceDataApi.reducer,
  [reportsApi.reducerPath]: reportsApi.reducer,
  [userPreferencesApi.reducerPath]: userPreferencesApi.reducer,
  auth: authSlice.reducer,
});
